import { Button, IconEdit3, Popover } from '@odekoteam/doppio';
import { useState } from 'react';
import { Box } from 'theme-ui';

import Icon3Dots from '@/assets/images/Icon3Dots.svg?icon';
import IconCopy from '@/assets/images/IconCopy.svg?icon';
import IconTrash from '@/assets/images/IconTrash.svg?icon';
import { ModalDeleteHomepage } from '@/components/Collection/ModalDeleteHomepage';
import { ModalUpsertHomepage } from '@/components/Collection/ModalUpsertHomepage';
import {
  GetMasterHomepageForEditQuery,
  GetMasterHomepagesQuery,
} from '@/graphql/types/generated';

export function HomepageActionsMenu({
  onSaved,
  homepage,
  disabled,
  onDeleted,
  onDuplicated,
  masterHomepages,
}: {
  disabled?: boolean;
  onDeleted: () => void;
  onSaved: (id: string) => void;
  onDuplicated: (id: string) => void;
  homepage: NonNullable<
    GetMasterHomepageForEditQuery['masterHomepageForEdit']
  > | null;
  masterHomepages: GetMasterHomepagesQuery['masterHomepages'];
}) {
  const [isDeleteVisible, setIsDeleteVisible] = useState(false);
  const [upsertMode, setUpsertMode] = useState<
    'create' | 'edit' | 'duplicate' | null
  >(null);

  return (
    <>
      {disabled ? (
        <Button
          size="small"
          variant="tertiary"
          isDisabled={disabled}
          iconLeft={<Icon3Dots />}
        />
      ) : (
        <Popover.Root>
          <Popover.Trigger>
            <Button size="small" variant="tertiary" iconLeft={<Icon3Dots />} />
          </Popover.Trigger>
          <Popover.Content align="left">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                m: -2,
                '& > *:last-child, & > *:last-child *': {
                  color: '#F4230B !important',
                },
                '& > *': {
                  width: '100% !important',
                  justifyContent: 'flex-start !important',
                },
              }}
            >
              <Button
                size="small"
                variant="ghost"
                iconLeft={<IconEdit3 />}
                onPress={() => setUpsertMode('edit')}
              >
                Edit Homepage
              </Button>
              <Button
                size="small"
                variant="ghost"
                iconLeft={<IconCopy />}
                onPress={() => setUpsertMode('duplicate')}
              >
                Duplicate Homepage
              </Button>
              <Button
                size="small"
                variant="ghost"
                iconLeft={<IconTrash />}
                onPress={() => setIsDeleteVisible(true)}
              >
                Delete Homepage
              </Button>
            </Box>
          </Popover.Content>
        </Popover.Root>
      )}
      <ModalUpsertHomepage
        mode={upsertMode}
        homepage={homepage}
        close={() => setUpsertMode(null)}
        masterHomepages={masterHomepages}
        onSaved={(id) => {
          upsertMode === 'duplicate' ? onDuplicated(id) : onSaved(id);
          setUpsertMode(null);
        }}
      />
      <ModalDeleteHomepage
        visible={isDeleteVisible}
        masterHomepage={homepage}
        onDeleted={() => {
          setIsDeleteVisible(false);
          onDeleted();
        }}
        onClose={() => setIsDeleteVisible(false)}
      />
    </>
  );
}
